import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy public trade log, retired. Permanent (301) redirect to the audited
// Performance Record, the canonical verified surface for historical outcomes.
export const Route = createFileRoute("/trade-log")({
  beforeLoad: () => {
    throw redirect({ to: "/track-record", statusCode: 301 });
  },
});
